// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 984 ? "reactPlayerPreview" : chunkId) + "." + {"48":"69e6bdc9","272":"b68f588a","852":"50ee4536","984":"8a17c73a"}[chunkId] + ".chunk.js";
};